import React from "react";
import {borderColors, getLineColor, getLineLabel} from "../../../utils/chartUtils";
import PropTypes from "prop-types";
import {isAdminAsPartner, isPartner} from "../../../utils/authUtils";
import {isMobileVerticalScreen} from "../../../utils/displayUtils";

ChartLegend.propTypes = {
    type: PropTypes.oneOf(["line", "doughnut"]),
    lines: PropTypes.arrayOf(PropTypes.string),
    displayedLines:PropTypes.arrayOf(PropTypes.any),
    onClickReduxActionType:PropTypes.string,
};

ChartLegend.defaultProps = {
    type: "line"
};

export default function ChartLegend(props) {
    const {type, lines, displayedLines, toggleChartLegend, isFullWidthChart} = props;
    const isLoggedAsPartner = isPartner() || isAdminAsPartner();
     const isMultipleLegendRows = isFullWidthChart && !isMobileVerticalScreen();


     const calcRows = () => {
         if (!lines) {
             return 1;
         }
         let rows = lines?.length > 11 ? 2 : 1;
         return (isMultipleLegendRows ? rows * 2 : rows) + "";
     }

    const lineLegend = () =>
        <div id="legend" className='po-chart-legends row' style={{maxHeight: "350px", paddingInlineStart: "0"}}>
            <ul style={{columnCount: calcRows(), paddingInlineStart: "0"}}>
                {
                    lines.map((line, idx) =>
                        <li className={displayedLines.includes(line) ? null : "disabled"} key={line}
                            onClick={() => toggleChartLegend(line)}>
                            <span style={{backgroundColor: getLineColor(line, idx)}}/>
                            {getLineLabel(line, isLoggedAsPartner, idx)}
                        </li>)
                }
            </ul>
        </div>;

    const doughnutLegend = () =>
        <div id="legend" className='po-chart-legends row'  style={{maxHeight: "370px"}}>
            <ul style={{columnCount: calcRows(), paddingInlineStart: "0"}}>
                {
                    lines.map((line, idx) =>
                        <li className={displayedLines.includes(line) ? null : "disabled"} key={line}
                            onClick={() => toggleChartLegend(line)}>
                            <span style={{backgroundColor: borderColors[idx]}}/>
                            {line}
                        </li>)
                }
            </ul>
        </div>;

    return (
        <div className='po-chart-legends row'>
                {
                   type === "line" ? lineLegend() : doughnutLegend()
                }
        </div>
    )
}